// TODO add typing and error proofing
export const parseApiError = (error: any) => {
  if (error.detail?.length > 0 && typeof error.detail[0].msg === "string") {
    return error.detail[0].msg;
  } else if (error?.message) {
    return error.message;
  }
  return "";
};
